<template>
  <!-- 订单详情 -->
  <div class="m-t-15">
    <div class="card">
      <div class="section">
        <base-section-title class="section-title" title="订单信息" />

        <div class="section-content">
          <jczh-descriptions
            :info="formData.purchaser"
            :option="orderOptions"
            :el-attrs="{
              size: 'medium',
              column: 3,
              labelStyle: {
                whiteSpace: 'nowrap'
              }
            }"
          />
        </div>
      </div>
    </div>

    <div class="card">
      <div class="section">
        <base-section-title class="section-title" title="采购信息" />

        <div
          v-for="(item, index) in orderList || []"
          :key="index"
          class="m-b-30"
        >
          <item-table
            ref="itemTable"
            :order-data="getOrderData(item)"
            :table-list="item.itemList || []"
          />
        </div>
      </div>
    </div>

    <!-- 审批备注 -->
    <record-remark v-if="requestQuery.pageFrom == 'auditDetail'" :remark-list="remarkList" />
  </div>
</template>

<script>
// 组件
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import ItemTable from '@/components/order/Order/ItemTable'
import RecordRemark from '@/components/common/RecordRemark'

// 数据字典
import { purchaseOrderSourceTypeDict } from '@/dictionary/order'

// 后端api接口
import { getPurchaseOrderDetailApi } from '@/api/order-views/order'

export default {
  name: 'PurchaseOrderInfo',

  components: {
    BaseSectionTitle,
    ItemTable,
    RecordRemark
  },

  props: {
    requestQuery: {
      type: Object,
      required: true
    },

    // 备注列表
    remarkList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },

  data() {
    return {
      // 字典
      purchaseOrderSourceTypeDict,

      // 详情
      detailInfo: {},

      formData: {
        order: {
          sourceType: '',
          releaseTime: ''
        },
        purchaser: {
          purchaseCompanyName: '',
          purchaseDeptId: '',
          purchaseDeptName: '',
          purchaseCreateUserName: ''
        }
      },

      orderList: [],

      orderOptions: [
        {
          label: '订单来源',
          prop: 'sourceType',
          filter: () =>
            purchaseOrderSourceTypeDict.translate(
              this.formData.order.sourceType
            ).label || '-'
        },
        { label: '所属公司', prop: 'purchaseCompanyName' },
        { label: '所属部门', prop: 'purchaseDeptName' },
        { label: '采购执行人', prop: 'purchaseExecutorName' },
        {
          label: '订单日期',
          prop: 'releaseTime',
          filter: () => this.formData.order.releaseTime || '-'
        }
      ]
    }
  },

  watch: {
    'requestQuery.orderId': {
      handler() {
        this.getPurchaseOrderDetail()
      },
      immediate: true
    }
  },

  methods: {
    // 获取详情
    getPurchaseOrderDetail() {
      if (!this.requestQuery.orderId) return
      getPurchaseOrderDetailApi(this.requestQuery.orderId)
        .then(res => {
          const data = res?.data || {}
          this.detailInfo = data

          this.formData = {
            order: data.order || {},
            purchaser: data.purchaser || {}
          }

          this.orderList = [
            { order: data.order || {}, itemList: data.items || [] }
          ]
          this.$emit('getDetail', data)
        })
        .catch(err => {
          this.$message.error(err?.message || '获取详情失败')
        })
    },

    /**
     * 获取表格上方显示信息
     */
    getOrderData(item) {
      const totalCount = item.itemList.reduce((prev, cur) => {
        return prev + Number(cur.itemNum || 0)
      }, 0)
      const totalPrice = item.itemList.reduce((prev, cur) => {
        return prev + Number(cur.totalPrice || 0)
      }, 0).toFixed(2)
      return {
        orderCode: item?.order?.orderCode || '',
        totalPrice,
        count: totalCount, // 采购数量
        supplierName: item?.order?.supplierName || '',
        contactUserName: item?.order?.contactUserName || '',
        contactUserPhone: item?.order?.contactUserPhone || '',
        contactUserEmail: item?.order?.contactUserEmail || ''
      }
    }
  }
}
</script>
